import React from "react";
import { getDate } from "utils/formatDate";

const LogTableRows = ({ list, pageIndex, pageSize, onShowDetail }) => {
  if (!list || list.length === 0) {
    return (
      <div className="custom-table-row">
        <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
          Không có dữ liệu
        </div>
      </div>
    );
  }
  return list.map((item, index) => (
    <div className="custom-table-row" key={"item" + index} style={{minHeight:"40px"}}>
      <div className="custom-table-cell" style={{ width: "10%" }}>
        <span className="mobile-column-name color7-bold">STT</span>
        <div className="center-wrapper" >
          <p className="text-center color7">{(pageIndex - 1) * pageSize + index + 1}</p>
        </div>
      </div>
      <div className="custom-table-cell" style={{ width: "20%" }}>
        <span className="mobile-column-name color7-bold">Người thực hiện</span>
        <div className="center-wrapper">
          <a
            className="profile_name word-break red"
            style={{
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              margin: 0,
              cursor: "pointer",
              color: "#007bff",
              textDecoration: "underline"
            }}
            onClick={() => onShowDetail(item)}
          >
            {item.CreatedUser}
          </a>
        </div>
      </div>
      <div className="custom-table-cell" style={{ width: "15%" }}>
        <span className="mobile-column-name color7-bold">Thời gian thực hiện</span>
        <div className="center-wrapper color7">
          <p className="text-left text-truncate"
            style={{
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              margin: 0,
            }}>
            {getDate(item.CreatedTime)}
          </p>
        </div>
      </div>
      <div className="custom-table-wrapper" style={{ width: "55%" }}>
        <span className="mobile-column-name color7-bold">Nội dung</span>
        <div className="">
          <p className="text-center " style={{
            maxWidth: "100%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: 0,
          }}>
            {item.Note}
          </p>
        </div>
      </div>
    </div>
  ));
};

export default LogTableRows;